import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

export const FeatureSection = () => {
  return (
    <section id="features" className="py-24 bg-meetoi-offwhite relative overflow-hidden">
      {/* Decorative background path */}
      <svg className="absolute w-full h-full top-0 left-0 opacity-40 pointer-events-none" viewBox="0 0 1440 600" fill="none">
        <path d="M-100 300 C 300 100, 800 500, 1500 200" stroke="#BFE3E8" strokeWidth="2" strokeDasharray="8 8" />
      </svg>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-20">
          <h2 className="font-sora text-3xl md:text-4xl font-bold text-meetoi-navy">Everything you need to build lasting relationships</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
          
          {/* Feature 1: Share Instantly */}
          <div className="flex flex-col items-center text-center">
            <div className="w-full h-48 bg-meetoi-blue/5 rounded-3xl border border-meetoi-blue/10 mb-8 flex items-center justify-center relative overflow-hidden">
              <div className="w-24 h-36 bg-white rounded-2xl shadow-md border border-meetoi-aqua/30 flex flex-col items-center p-3 relative z-10">
                <div className="w-8 h-8 rounded-full bg-meetoi-offwhite mb-2"></div>
                <div className="w-12 h-2 bg-meetoi-offwhite rounded mb-4"></div>
                <div className="w-14 h-14 bg-meetoi-navy rounded-lg flex items-center justify-center mt-auto mb-2">
                  <SafeIcon icon={FiIcons.FiMaximize} className="text-white" />
                </div>
              </div>
              <div className="absolute right-4 top-1/2 -translate-y-1/2 w-8 h-8 bg-meetoi-coral rounded-full flex items-center justify-center shadow-lg opacity-80">
                <SafeIcon icon={FiIcons.FiWifi} className="text-white text-sm" />
              </div>
            </div>
            <h3 className="font-sora font-semibold text-xl text-meetoi-navy mb-3">Share instantly</h3>
            <p className="font-manrope text-sm text-meetoi-text/70 mb-4 px-2">Share your profile via QR, NFC, link, or email—anytime, anywhere.</p>
            <Link to="/register" className="font-manrope text-sm font-bold text-meetoi-blue hover:text-meetoi-navy flex items-center transition-colors">
              Learn more <SafeIcon icon={FiIcons.FiArrowRight} className="ml-1" />
            </Link>
          </div>

          {/* Feature 2: Capture What Matters */}
          <div className="flex flex-col items-center text-center">
            <div className="w-full h-48 bg-meetoi-navy/5 rounded-3xl border border-meetoi-navy/10 mb-8 flex items-center justify-center">
              <div className="w-48 bg-white rounded-xl shadow-md border border-meetoi-aqua/30 p-4 text-left">
                <div className="flex items-center gap-2 mb-3">
                  <SafeIcon icon={FiIcons.FiCheckSquare} className="text-meetoi-blue" />
                  <div className="w-16 h-2 bg-meetoi-offwhite rounded"></div>
                </div>
                <div className="space-y-2">
                  <div className="flex items-center gap-2">
                    <div className="w-4 h-4 rounded-full bg-meetoi-offwhite"></div>
                    <div className="w-20 h-2 bg-meetoi-offwhite rounded"></div>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-4 h-4 rounded-full bg-meetoi-offwhite"></div>
                    <div className="w-24 h-2 bg-meetoi-offwhite rounded"></div>
                  </div>
                </div>
              </div>
            </div>
            <h3 className="font-sora font-semibold text-xl text-meetoi-navy mb-3">Capture what matters</h3>
            <p className="font-manrope text-sm text-meetoi-text/70 mb-4 px-2">Save notes, tags, and context so you always remember.</p>
            <Link to="/register" className="font-manrope text-sm font-bold text-meetoi-blue hover:text-meetoi-navy flex items-center transition-colors">
              Learn more <SafeIcon icon={FiIcons.FiArrowRight} className="ml-1" />
            </Link>
          </div>

          {/* Feature 3: Follow Up With Ease */}
          <div className="flex flex-col items-center text-center">
            <div className="w-full h-48 bg-meetoi-coral/5 rounded-3xl border border-meetoi-coral/10 mb-8 flex items-center justify-center">
              <div className="w-48 bg-white rounded-xl shadow-md border border-meetoi-aqua/30 p-3">
                <div className="flex items-center gap-3 mb-3 pb-3 border-b border-meetoi-offwhite">
                  <div className="w-8 h-8 rounded-full bg-meetoi-coral/20 flex items-center justify-center text-meetoi-coral">
                    <SafeIcon icon={FiIcons.FiBell} />
                  </div>
                  <div className="text-left">
                    <div className="text-[10px] font-bold text-meetoi-navy">Follow up with Alex</div>
                    <div className="text-[9px] text-meetoi-text/50">Tomorrow, 10:00 AM</div>
                  </div>
                </div>
                <div className="w-full py-1.5 bg-meetoi-offwhite rounded text-[10px] font-bold text-meetoi-navy text-center">Mark as done</div>
              </div>
            </div>
            <h3 className="font-sora font-semibold text-xl text-meetoi-navy mb-3">Follow up with ease</h3>
            <p className="font-manrope text-sm text-meetoi-text/70 mb-4 px-2">Smart reminders help you stay thoughtful and consistent.</p>
            <Link to="/register" className="font-manrope text-sm font-bold text-meetoi-blue hover:text-meetoi-navy flex items-center transition-colors">
              Learn more <SafeIcon icon={FiIcons.FiArrowRight} className="ml-1" />
            </Link>
          </div>

          {/* Feature 4: See Your Growth */}
          <div className="flex flex-col items-center text-center">
            <div className="w-full h-48 bg-meetoi-aqua/10 rounded-3xl border border-meetoi-aqua/30 mb-8 flex flex-col items-center justify-center p-4">
              <div className="w-full bg-white rounded-xl shadow-sm border border-meetoi-aqua/30 p-3 text-left mb-3">
                <div className="text-[10px] font-bold text-meetoi-navy mb-1">Relationship Strength</div>
                <div className="text-2xl font-sora font-bold text-meetoi-navy">82%</div>
                <svg className="w-full h-6 mt-2" viewBox="0 0 100 20" preserveAspectRatio="none">
                  <path d="M0 20 Q 25 10, 50 15 T 100 5 L 100 20 Z" fill="#BFE3E8" opacity="0.5" />
                  <path d="M0 20 Q 25 10, 50 15 T 100 5" fill="none" stroke="#1985A1" strokeWidth="2" />
                </svg>
              </div>
            </div>
            <h3 className="font-sora font-semibold text-xl text-meetoi-navy mb-3">See your growth</h3>
            <p className="font-manrope text-sm text-meetoi-text/70 mb-4 px-2">Understand your network and nurture meaningful connections.</p>
            <Link to="/register" className="font-manrope text-sm font-bold text-meetoi-blue hover:text-meetoi-navy flex items-center transition-colors">
              Learn more <SafeIcon icon={FiIcons.FiArrowRight} className="ml-1" />
            </Link>
          </div>

        </div>
      </div>
    </section>
  );
};